import React from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import { useSelector } from "react-redux";
import IAppState from "infrastructure/store/IAppState";
import ContractingState from "infrastructure/store/contracting/ContractingState";
import RenderWrapper from "features/shared/components/renderWrapper/RenderWrapper";
import { ContractingFormsMap } from "features/contracting/sections/contractingForms/ContractingFormsMap";
import ContractingStepConfiguration from "features/contracting/models/ContractingStepConfiguration";
import ContractingStepper from "features/contracting/components/ContractingStepper";
import { useContractingInit } from "features/contracting/hooks/useContractingInit";

type Props = {
  steps: ContractingStepConfiguration[];
  routePrefix: string;
  enableSaveBtn: boolean;
  enableBackToLoginBtn: boolean;
};

const ContractingMultiStepFormSection = ({
  steps,
  routePrefix,
  enableSaveBtn,
  enableBackToLoginBtn,
}: Props) => {
  //#region router
  const match = useRouteMatch();
  //#endregion router

  //#region store
  const contractingProgress = useSelector<IAppState, ContractingState>(
    (store) => store.contracting
  ).progress;
  //#endregion store

  //#region init contracting
  const { afterInit } = useContractingInit({
    stepsConfig: steps,
    routePrefix: routePrefix,
  });
  //#endregion init contracting

  //#region sub-renders
  const renderFormSteps = (): JSX.Element[] => {
    let result: JSX.Element[] = [];
    const stepsLenght = steps.length;

    for (let i = 0; i < stepsLenght; i++) {
      const step = steps[i];
      const prevStep = i > 0 ? steps[i - 1] : undefined;
      const nextStep = i + 1 < stepsLenght ? steps[i + 1] : undefined;

      const Form = ContractingFormsMap[step.component];

      if (Form !== undefined) {
        result.push(
          <Route path={`${match.path}/${step.route}`} key={step.component}>
            <Form
              actualStep={step}
              prevStep={prevStep}
              nextStep={nextStep}
              enableSaveBtn={enableSaveBtn}
              enableBackToLoginBtn={enableBackToLoginBtn}
            />
          </Route>
        );
      } else {
        console.warn(`Form with type '${step.component}' doesn't exists.`);
      }
    }

    return result;
  };
  //#endregion sub-renders

  //#region render
  return (
    <RenderWrapper isVisible={() => afterInit}>
      <ContractingStepper steps={steps} />
      <Switch>
        {renderFormSteps()}
        <Redirect from="*" push to={contractingProgress.actualStepRoute!} />
      </Switch>
    </RenderWrapper>
  );
  //#endregion render
};

export default ContractingMultiStepFormSection;
